import {IRoutableModule} from '../../router/routing.infra';
import {LoginView} from './login.view';
import {LoginMobileView} from './login-mobile.view';
import {loginRouteLoader} from './login.loader';

export default {
    loader: loginRouteLoader,
    Component: LoginView,
    MobileComponent: LoginMobileView,
    storeAs: 'loginStore'
} as IRoutableModule;
